export const boxPlot = {
    boxPlot: {
        style: {
            lineWidth: 1
        }
    },
    label: {
        style: {
            lineWidth: 2
        }
    }
};
//# sourceMappingURL=box-plot.js.map
